export default __webpack_public_path__ + "static/about-us-sustainability-fb26bb6a9a47cb41dc91cf7442a5d927.webp";